<template>
  <re-multi-choice
    :model-value="locale"
    :options="langs"
    :size="size"
    @update:model-value="changeLang"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute, useRouter } from 'vue-router'

import { useConfig } from '@/composables/useConfig'
import { useCurUser } from '@/composables/useCurUser'
import store from '@/store'

defineProps({
  size: {
    type: String,
    default: 'sm',
  },
})

const router = useRouter()
const route = useRoute()
const { hasRole, patch } = useCurUser()
const { locale } = useI18n()
const config = useConfig()
const langs = computed(() => {
  const l = config.ALL_LANGS?.map((lang) => ({
    value: lang, // eg. 'nl-BE'
    label: lang.split('-')[0].toUpperCase(),
  }))

  if (hasRole('developer') && l) {
    l.push({ value: 'technical', label: 'technical' })
  }

  return l
})

const changeLang = (lang: string) => {
  if (store.getters.isAuthenticated && lang !== locale.value) {
    patch({
      preferred_lang: lang,
    })
  }

  router.push({
    name: route.name,
    query: route.query,
    params: {
      ...route.params,
      lang,
    },
  })
}
</script>
